import React from 'react';
import { useTranslation } from 'react-i18next';
import moment, { Moment } from 'moment';
import { DatePicker, DatePickerProps } from 'antd';
import localeFR from 'antd/es/date-picker/locale/fr_FR';
import localeEN from 'antd/es/date-picker/locale/en_US';
import { DEFAULT_DISPLAY_DATE_FORMAT } from '@/config';

type DatePickerPropNTA = {
  lessThanToday?: boolean;
} & DatePickerProps;

export default function AppDatePicker({ value, lessThanToday, onChange, ...props }: DatePickerPropNTA) {
  const { t, i18n } = useTranslation();
  const onDateChange = v => {
    if (onChange) {
      onChange(v ? moment(v).endOf('day') : null, '');
    }
  };
  if (value && typeof value === 'string') {
    value = moment(value).endOf('day');
  }
  const locale = React.useMemo(() => {
    if (i18n.language === 'fr') {
      return localeFR;
    }
    return localeEN;
  }, [i18n.language]);

  const otherConfig = React.useMemo(() => {
    if (lessThanToday) {
      return {
        disabledDate: (date: Moment) => date.startOf('day').isAfter(moment()),
      };
    }
    return {};
  }, [lessThanToday]);
  return (
    <DatePicker
      format={DEFAULT_DISPLAY_DATE_FORMAT}
      placeholder={t('Select date')}
      {...(props as any)}
      value={value}
      locale={locale}
      inputReadOnly={false}
      showTime={false}
      onChange={onDateChange}
      autoComplete="off"
      {...otherConfig}
    />
  );
}
